import React, { Component }     from "react";
import { Button, MenuItem, Modal, Glyphicon, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
//import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/FMS"
import { invokeSetAddFMSAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import '../../css/assessment/FMSForm.css';



let assess_form;
let total_score;

const tooltipShoulderLabel = ( <Tooltip id="tooltip">
                                If pain presents with the shoulder clearing test, score a 0 for the respective side.
                           </Tooltip> );


const tooltipExtClearingTestLabel = ( <Tooltip id="tooltip">
                                           If pain presents with the extension clearing test, the score will result in a 0.
                                      </Tooltip> );

const tooltipFlexionLabel = ( <Tooltip id="tooltip">
                                If pain presents with the flexion clearing test, the score will result in a 0.
                              </Tooltip> );

export default class FMSForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            deep_squat:                      "",
            left_hurdle_step:                "",
            right_hurdle_step:               "",
            left_inline_lunge:               "",
            right_inline_lunge:              "",
            left_shoulder_mobility:          "",
            right_shoulder_mobility:         "",
            left_active_straight_leg_raise:  "",
            right_active_straight_leg_raise: "",
            trunk_stability_pushup:          "",
            left_rotary_stability:           "",
            right_rotary_stability:          "",
            notes:                           ""
        }

       //this.setUserFormData = this.setUserFormData.bind(this);
       this.handleInputChange = this.handleInputChange.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getFMSAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);


//  deep_squat, left_hurdle_step, right_hurdle_step, left_inline_lunge, right_inline_lunge, left_shoulder_mobility,
// right_shoulder_mobility, left_active_straight_leg_raise, right_active_straight_leg_raise, trunk_stability_pushup
// left_rotary_stability, right_rotary_stability

            if(results) {
                var deep_squat                       = results.data[0].deep_squat;
                var left_hurdle_step                 = results.data[0].left_hurdle_step;
                var right_hurdle_step                = results.data[0].right_hurdle_step
                var left_inline_lunge                = results.data[0].left_inline_lunge
                var right_inline_lunge               = results.data[0].right_inline_lunge
                var left_shoulder_mobility           = results.data[0].left_shoulder_mobility;
                var right_shoulder_mobility          = results.data[0].right_shoulder_mobility;
                var left_active_straight_leg_raise   = results.data[0].left_active_straight_leg_raise;
                var right_active_straight_leg_raise  = results.data[0].right_active_straight_leg_raise;
                var trunk_stability_pushup           = results.data[0].trunk_stability_pushup;
                var left_rotary_stability            = results.data[0].left_rotary_stability;
                var right_rotary_stability           = results.data[0].right_rotary_stability;
                var notes                            = results.data[0].notes;

                this.setState({
                    deep_squat:                      deep_squat,
                    left_hurdle_step:                left_hurdle_step,
                    right_hurdle_step:               right_hurdle_step,
                    left_inline_lunge:               left_inline_lunge,
                    right_inline_lunge:              right_inline_lunge,
                    left_shoulder_mobility:          left_shoulder_mobility,
                    right_shoulder_mobility:         right_shoulder_mobility,
                    left_active_straight_leg_raise:  left_active_straight_leg_raise,
                    right_active_straight_leg_raise: right_active_straight_leg_raise,
                    trunk_stability_pushup:          trunk_stability_pushup,
                    left_rotary_stability:           left_rotary_stability,
                    right_rotary_stability:          right_rotary_stability,
                    notes:                           notes
                });
            }
        }
    }

    isNumberKey(value) {
        // the below regex expression allow for numbers and decimals but not a leading decimal; like .07
          var regexp = /^[+-]?(?=.?\d)\d*(\.\d{0,9})?$/;
          var number_valid = regexp.test(value)

          if(!number_valid && value.length != 0)
              return false

         return true;
    }

    handleInputChange(event) {

          const target = event.target;
          var   value = target.type === 'checkbox' ? target.checked : target.value;
          const name = target.name;

          // Check if Value is a number (decimal point is allowed) //
          if(this.isNumberKey(value)) {
              //console.log("name: " + name);
              //console.log("value: " + value);
              //if(value == "" || value == undefined || value == null) value = 0;

              this.setState({
                [name]: value
              });
          }
    }

    isObject(obj) {
        return obj != null && obj.constructor.name === "Object"
    }

    getTotalScore () {
        var total_score = 0;

        var deep_squat                       = parseInt(this.state.deep_squat);
        var left_hurdle_step                 = parseInt(this.state.left_hurdle_step);
        var right_hurdle_step                = parseInt(this.state.right_hurdle_step);

        var left_inline_lunge                = parseInt(this.state.left_inline_lunge);
        var right_inline_lunge               = parseInt(this.state.right_inline_lunge);
        var left_shoulder_mobility           = parseInt(this.state.left_shoulder_mobility);
        var right_shoulder_mobility          = parseInt(this.state.right_shoulder_mobility);
        var left_active_straight_leg_raise   = parseInt(this.state.left_active_straight_leg_raise);
        var right_active_straight_leg_raise  = parseInt(this.state.right_active_straight_leg_raise);
        var trunk_stability_pushup           = parseInt(this.state.trunk_stability_pushup);
        var left_rotary_stability            = parseInt(this.state.left_rotary_stability);
        var right_rotary_stability           = parseInt(this.state.right_rotary_stability);
        // var notes                            = this.state.notes;


        var hurdle_step = left_hurdle_step;
        if(right_hurdle_step < left_hurdle_step) hurdle_step = right_hurdle_step

        var lunge = left_inline_lunge;
        if(right_inline_lunge < left_inline_lunge) lunge = right_inline_lunge

        var mobility = left_shoulder_mobility;
        if(right_shoulder_mobility < left_shoulder_mobility) mobility = right_shoulder_mobility

        var leg_raise = left_active_straight_leg_raise;
        if(right_active_straight_leg_raise < left_active_straight_leg_raise) leg_raise = right_active_straight_leg_raise

        var stability = left_rotary_stability;
        if(right_rotary_stability < left_rotary_stability) stability = right_rotary_stability

        total_score = deep_squat + hurdle_step + lunge + mobility + leg_raise + trunk_stability_pushup + stability;
        return total_score;
    }

    onChange = () => {
        this.setState({
            total_score: this.getTotalScore()
        })
    }

    onSubmit = async () => {

        var client_id        = this.props.clientId;
        var assessment_id    = this.props.assessmentId;
        var assessment_type  = 3; // FMS rom is #3 in dropdown
        var deep_squat                       = this.state.deep_squat;
        var left_hurdle_step                 = this.state.left_hurdle_step;
        var right_hurdle_step                = this.state.right_hurdle_step;
        var left_inline_lunge                = this.state.left_inline_lunge;
        var right_inline_lunge               = this.state.right_inline_lunge;
        var left_shoulder_mobility           = this.state.left_shoulder_mobility;
        var right_shoulder_mobility          = this.state.right_shoulder_mobility;
        var left_active_straight_leg_raise   = this.state.left_active_straight_leg_raise;
        var right_active_straight_leg_raise  = this.state.right_active_straight_leg_raise;
        var trunk_stability_pushup           = this.state.trunk_stability_pushup;
        var left_rotary_stability            = this.state.left_rotary_stability;
        var right_rotary_stability           = this.state.right_rotary_stability;
        var notes                            = this.state.notes;

        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })


        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddFMSAssessment(action, assessment_id, client_id, deep_squat, left_hurdle_step, right_hurdle_step, left_inline_lunge, right_inline_lunge, left_shoulder_mobility, right_shoulder_mobility, left_active_straight_leg_raise, right_active_straight_leg_raise, trunk_stability_pushup, left_rotary_stability, right_rotary_stability, notes)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    render() {
        var total_score = this.getTotalScore();

        if(isNaN(total_score)) total_score = 0;
        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                { /*}<Form style      = {{textAlign:"left", fontSize: "20px !important"}}
                      className  = "assessmentHeartAndBloodForm"
                      schema     = {schema}
                      uiSchema   = {uiSchema}
                      formData   = {this.state.userFormData}
                      onChange   = {this.onChange} ref={(form) => {assess_form = form}}
                      onSubmit   = {this.onSubmit} ref={(form) => {assess_form = form}}
                      noValidate = {true}
                >*/ }

                    <span className="">
                        <div className="fmsTitle">Deep Squat</div>
                        <div className="fmsSubTitle">Score of 0-3</div>
                        <input
                          //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                          name      = "deep_squat"
                          className = "assessmentFMS_textfield_long_width"
                          value     = {this.state.deep_squat}
                          onChange  = {this.handleInputChange} />
                    </span>
                    <br/><br/>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Left Hurdle Step</div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "left_hurdle_step"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.left_hurdle_step}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide" style={{display: "inline-block"}}>
                            <div className="fmsTitle">Right Hurdle Step</div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "right_hurdle_step"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.right_hurdle_step}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide"> </span>
                    <br/>
                    <br/>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Left Inline Lunge</div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              type      = "number"
                              name      = "left_inline_lunge"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.left_inline_lunge}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Right Inline Lunge</div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "right_inline_lunge"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.right_inline_lunge}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide"> </span>

                    <br/>
                    <br/>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Left Shoulder Mobility
                                <OverlayTrigger placement="top" overlay={tooltipShoulderLabel} >
                                    <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"0px", left:"5px", color:"#666"}}/>
                                </OverlayTrigger>
                            </div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "left_shoulder_mobility"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.left_shoulder_mobility}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Right Shoulder Mobility
                                <OverlayTrigger placement="top" overlay={tooltipShoulderLabel} >
                                    <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"0px", left:"5px", color:"#666"}}/>
                                </OverlayTrigger>
                            </div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "right_shoulder_mobility"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.right_shoulder_mobility}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide"> </span>
                    <br/>
                    <br/>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Left Active Straight Leg Raise</div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "left_active_straight_leg_raise"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.left_active_straight_leg_raise}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Right Active Straight Leg Raise</div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "right_active_straight_leg_raise"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.right_active_straight_leg_raise}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide"> </span>

                    <br/>
                    <br/>

                    <span className="">
                        <div className="fmsTitle">Trunk Stability Pushup
                            <OverlayTrigger placement="top" overlay={tooltipExtClearingTestLabel} >
                                <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"0px", left:"5px", color:"#666"}}/>
                            </OverlayTrigger>
                        </div>
                        <div className="fmsSubTitle">Score of 0-3</div>
                        <input
                          //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                          name      = "trunk_stability_pushup"
                          className = "assessmentFMS_textfield_long_width"
                          value     = {this.state.trunk_stability_pushup}
                          onChange  = {this.handleInputChange} />
                    </span>

                    <br/>
                    <br/>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Left Rotary Stability
                                <OverlayTrigger placement="top" overlay={tooltipFlexionLabel} >
                                    <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"0px", left:"5px", color:"#666"}}/>
                                </OverlayTrigger>
                            </div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "left_rotary_stability"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.left_rotary_stability}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Right Rotary Stability
                                <OverlayTrigger placement="top" overlay={tooltipFlexionLabel} >
                                    <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"0px", left:"5px", color:"#666"}}/>
                                </OverlayTrigger>
                            </div>
                            <div className="fmsSubTitle">Score of 0-3</div>
                            <input
                              //type      = "number" // causes errant behavior if a user scrolls while the tf is focused on
                              name      = "right_rotary_stability"
                              className = "assessmentFMS_textfield_long_width"
                              value     = {this.state.right_rotary_stability}
                              onChange  = {this.handleInputChange} />
                        </span>
                        <span className="fmsSideBySide"> </span>
                        <br/><br/>
                        <span className="fmsSideBySide">
                            <div className="fmsTitle">Notes</div>
                            <textarea
                                  style     = {{width: 500, height: 120, fontSize: 20}}
                                  name      = "notes"
                                  className = "assessmentFMS_textfield_long_width"
                                  value     = {this.state.notes}
                                  onChange  = {this.handleInputChange} />
                        </span>
                    <br/><br/><br/>

                    <div className="fmsScoreTitle">Total FMS Score: { total_score } </div>
                    <br/><br/>
                    <Row className="grid" >
                          <Col xs={6} sm={6} md={6}>
                                <span onClick = { () => this.props.cancelAssessment()}
                                    style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        type    = "button"
                                        text    = "Cancel"
                                        style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                      />
                                </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                                <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                        //disabled={!this.validateForm()}
                                        isLoading={this.state.isLoading}
                                        text    = "Save"
                                        type    = "submit"
                                        onClick = {this.onSubmit }
                                        loadingText="Saving …"
                                      />
                                </span>
                            </Col>
                     </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/FMSForm.js